/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { DefaultShipping, DefaultBilling, addressAssest } from '@/store/modules/checkout/defaultValues'

export default {
  setStepPosition (state, payload) {
    state.stepPosition = { ...{
      index: payload.index || 0,
      value: payload.value || ''
    } }
  },
  setShippingAddress (state, newAddress) {
    state.shippingAddress = newAddress || { ...DefaultShipping }
  },
  setBillingAddress (state, newAddress) {
    state.billingAddress = newAddress || { ...DefaultBilling }
  },
  setPaymentSelected (state, paymentSelected) {
    state.paymentMethod.current = paymentSelected
    state.placeOrderAction = null
    state.postPlaceOrderAction = null
    state.paymentMethod.paymentMethodAdditional = {}
  },
  setPaymentMethods (state, list) {
    state.paymentMethods = list
  },
  setShippingMethods (state, list) {
    state.shippingMethods = list
  },
  setShippingMethod: (state, shippingMethod) => { state.shippingMethod = shippingMethod },
  setCountries (state, countries) {
    state.countries = countries
  },
  setPlaceOrderAction (state, fx) {
    state.placeOrderAction = fx
  },
  setPostPlaceOrderAction (state, fx) {
    state.postPlaceOrderAction = fx
  },
  setPaymentMethodAdditional (state, paymentMethodAdditional) {
    state.paymentMethod.paymentMethodAdditional = paymentMethodAdditional
  },
  paymentMethodCurrent (state, current) {
    state.paymentMethod.current = current
  },
  setTempOrder (state, order) {
    state.tmpOrder = order
  },
  terms: (state, terms) => { state.terms = terms },
  updCart (state, cart) {
    // payment methods
    state.paymentMethods = cart.available_payment_methods
    state.paymentMethod.current = cart.selected_payment_method.code || ''
    // billing address
    if (cart.billing_address && cart.billing_address.city) {
      state.billingAddress = addressAssest({ ...DefaultBilling, ...cart.billing_address }) || { ...DefaultBilling }
    }
    if (cart.shipping_addresses && cart.shipping_addresses.length) {
      const shippingAddress = cart.shipping_addresses[0]
      // shipping methods
      state.shippingMethods = shippingAddress.available_shipping_methods.filter(item => item.available)
      state.shippingMethod = shippingAddress.selected_shipping_method ? shippingAddress.selected_shipping_method.carrier_code : null
      // shipping address
      state.shippingAddress = addressAssest({ ...DefaultShipping, ...shippingAddress }) || { ...DefaultShipping }
      delete state.shippingAddress['available_shipping_methods']
    } else {
      state.shippingMethods = []
    }
    if (cart.email) {
      state.email = cart.email
    }
    state.cart = cart
  },
  userInfo: (state, userInfo) => { state.userInfo = userInfo },
  setEmail (state, email) {
    state.cart.email = email
  },
  extensionAttributes: (state, extensionAttributes) => { state.extensionAttributes = extensionAttributes }
}
